var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8336d37-f9dd-46f2-8b4c-d4d0b64e6fc7",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 889.3027 918.5771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a4760449-0a46-45ea-907c-a9fc84974b6c,.f456157a-c5e0-4cb9-b818-133d481aaffe{fill:#fff;stroke:#1d1d1b;stroke-miterlimit:10;}.a4760449-0a46-45ea-907c-a9fc84974b6c{stroke-width:20px;}.f456157a-c5e0-4cb9-b818-133d481aaffe{stroke-width:15px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a4760449-0a46-45ea-907c-a9fc84974b6c",
    cx: 444.6514,
    cy: 186.5771,
    r: 176.5771
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a4760449-0a46-45ea-907c-a9fc84974b6c",
    d: "M512,418.6858a176.5771,176.5771,0,0,1,353.1542,0",
    transform: "translate(-67.3486 -53.4229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a4760449-0a46-45ea-907c-a9fc84974b6c",
    d: "M158.8458,418.6858a176.5771,176.5771,0,0,1,353.1542,0",
    transform: "translate(-67.3486 -53.4229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a4760449-0a46-45ea-907c-a9fc84974b6c",
    d: "M946.6514,418.6858c0,240.0513-194.6,434.6514-434.6514,434.6514S77.3486,658.7371,77.3486,418.6858H946.6514Z",
    transform: "translate(-67.3486 -53.4229)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a4760449-0a46-45ea-907c-a9fc84974b6c",
    d: "M294.6743,962c0-60.0128,97.3-108.6628,217.3257-108.6628S729.3257,901.9872,729.3257,962H294.6743Z",
    transform: "translate(-67.3486 -53.4229)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f456157a-c5e0-4cb9-b818-133d481aaffe",
    d: "M189.9362,325.0851c-3.0379,28.6693-1.0549,35.1453,4.2828,37.674,15.6294,7.4045,43.1024-40.3763,67.6946-33.2924,20.5029,5.9059,19.9361,44.4548,34.4022,45.5,17.0974,1.235,22.6906-52.2655,47.7192-56.5971,29.6226-5.1267,58.2441,63.507,78.7921,56.5971,15.5966-5.2448,7.5363-47.6212,24.4145-54.3776,14.1474-5.6633,33.26,13.9589,50.95,35.39",
    transform: "translate(-67.3486 -53.4229)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f456157a-c5e0-4cb9-b818-133d481aaffe",
    d: "M361.8511,161.5106c7.9446,7.7238,14.9412,10.3322,27.6836,8.1523,23.6483-4.0455,27.8746-44.5584,44.76-45.13,20.0748-.6792,28.8672,56.0858,49.1988,56.2273,20.9257.1456,28.7055-59.8658,49.5688-60.2963,22.8516-.4716,29.7383,71.1879,61.0361,76.9425,22.7232,4.1781,46.1993-22.9165,62.5614-48.5768",
    transform: "translate(-67.3486 -53.4229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f456157a-c5e0-4cb9-b818-133d481aaffe",
    d: "M527.2128,353.3161c36.0175-34.0128,51.2518-37.2094,58.3694-33.0565,10.9174,6.37,3.7539,30.6229,14.4268,35.5119,14.3359,6.5671,35.4471-33.4409,57.7069-28.8534,21.1869,4.3663,21.2735,44.57,38.8412,46.6094,20.45,2.374,31.6976-50.7829,56.5971-51.0484,25.3645-.2705,38.3277,54.6279,56.5972,52.1581,7.9008-1.068,15.13-10.2419,21.7167-51.7649",
    transform: "translate(-67.3486 -53.4229)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1413d6169a7b1e9d784d8dad7bba9db1.svg";
export { ForwardRef as ReactComponent };